
(function () {
  'use strict';

  const CONFIG = {
    swatchSelector: 'a.rcl__swatch[href*="/products/"]',
    pickerSelector: 'variant-picker[context="main_product"]',
    unavailableClass: 'bv-size-unavailable',
    opacity: '0.35'
  };

  // Shopify-Produktdaten zwischenspeichern
  const productCache = new Map();

  // Bereits beobachtete Rubik-Komponenten merken
  const observedRoots = new WeakSet();

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(',', '.');
  }

  // Ausgewählte Größe im Prestige-Theme auslesen
  function getSelectedSize() {
    const picker = document.querySelector(CONFIG.pickerSelector);

    if (!picker) return null;

    const selected = picker.querySelector(
      'input[type="radio"]:checked'
    );

    if (!selected) return null;

    const label = picker.querySelector(
      `label[for="${CSS.escape(selected.id)}"]`
    );

    return label?.textContent.trim() || null;
  }

  // Produktdaten von Shopify laden
  function getProduct(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const promise = fetch(
      `/products/${encodeURIComponent(handle)}.js`
    )
      .then(response => {
        if (!response.ok) {
          throw new Error('Produkt konnte nicht geladen werden');
        }

        return response.json();
      })
      .catch(error => {
        productCache.delete(handle);
        console.warn('[BV Size Check]', handle, error);
        return null;
      });

    productCache.set(handle, promise);

    return promise;
  }

  // Prüfen, ob eine Größe existiert und verfügbar ist
  function isSizeAvailable(product, size) {
    if (!product || !product.variants) return null;

    const options = (product.options || []).map(option =>
      typeof option === 'string' ? option : option.name
    );

    // Größenposition anhand des Optionsnamens bestimmen
    let sizeIndex = options.findIndex(option =>
      /größe|groesse|size/i.test(option || '')
    );

    // Bei eurem aktuellen Shop ist Größe Option 1
    if (sizeIndex === -1) sizeIndex = 0;

    const variant = product.variants.find(item => {
      const value = [
        item.option1,
        item.option2,
        item.option3
      ][sizeIndex];

      return normalize(value) === normalize(size);
    });

    return !!variant && variant.available === true;
  }

  // CSS innerhalb des Rubik Shadow DOM einfügen
  function installStyles(root) {
    if (root.querySelector('#bv-size-availability-style')) return;

    const style = document.createElement('style');

    style.id = 'bv-size-availability-style';

    style.textContent = `
      a.${CONFIG.unavailableClass} {
        opacity: ${CONFIG.opacity} !important;
        filter: grayscale(100%) !important;
      }
    `;

    root.appendChild(style);
  }

  // Alle Farbkacheln einer Rubik-Komponente prüfen
  async function updateRubik(root) {
    const size = getSelectedSize();

    if (!size) return;

    installStyles(root);

    const swatches = [
      ...root.querySelectorAll(CONFIG.swatchSelector)
    ];

    await Promise.all(swatches.map(async swatch => {
      const url = new URL(swatch.href, location.origin);

      const handle = url.pathname
        .split('/products/')[1]
        ?.split('/')[0];

      if (!handle) return;

      const product = await getProduct(handle);

      // Bei einem Ladefehler keine falsche Aussage treffen
      if (!product) return;

      const available = isSizeAvailable(product, size);

      swatch.classList.toggle(
        CONFIG.unavailableClass,
        !available
      );

      if (!available) {
        swatch.setAttribute(
          'aria-label',
          `${swatch.textContent.trim()} – Größe ${size} nicht verfügbar`
        );
      } else {
        swatch.removeAttribute('aria-label');
      }
    }));
  }

  // Alle Rubik-Komponenten auf der Seite finden
  function updateAll() {
    document
      .querySelectorAll('rubik-combined-listings')
      .forEach(element => {
        const root = element.shadowRoot;

        if (!root) return;

        observeRoot(root);
        updateRubik(root);
      });
  }

  // Änderungen innerhalb von Rubik beobachten
  function observeRoot(root) {
    if (observedRoots.has(root)) return;

    observedRoots.add(root);

    const observer = new MutationObserver(() => {
      installStyles(root);
      updateRubik(root);
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  // Größenänderungen erkennen
  let updateTimer;

  function scheduleUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(() => {
      updateAll();
    }, 200);
  }

  document.addEventListener('change', event => {
    if (
      event.target.matches(
        'variant-picker input[type="radio"]'
      )
    ) {
      scheduleUpdate();
    }
  }, true);

  document.addEventListener(
    'variant:change',
    scheduleUpdate
  );

  // Theme- und Rubik-Neudarstellungen beobachten
  const pageObserver = new MutationObserver(() => {
    scheduleUpdate();
  });

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Initiale Prüfung
  updateAll();

  console.log(
    '[BV Size Availability] Erweiterung gestartet.'
  );

})();
